export function About() {
  const copyIban = () => {
    navigator.clipboard.writeText('UA123456789012345678901234567').then(() => {
      const btn = document.querySelector('.default-copy-btn') as HTMLButtonElement;
      if (btn) {
        btn.textContent = 'Скопійовано!';
        setTimeout(() => {
          btn.textContent = 'Копіювати IBAN';
        }, 2000);
      }
    });
  };

  return (
    <div className="default-about-page">
      <section className="default-about-hero">
        <h1>жмут щастя</h1>
        <p>Благодійний фонд порятунку тварин</p>
      </section>

      <section className="default-about-content">
        <p className="default-about-intro">
          Кожна тварина заслуговує на другий шанс.
          Ми віримо, що любов і турбота можуть змінити світ — одну лапу за раз.
        </p>

        <p className="default-about-text">
          Благодійна організація "жмут щастя" заснована у 2019 році з єдиною метою — рятувати безпритульних тварин та шукати їм люблячі домівки.
        </p>

        <p className="default-about-text">
          Наш притулок розташований у Києві та наразі опікується понад двадцятьма тваринами — котами та собаками різного віку та характеру. Кожен з них має свою унікальну історію, і кожен заслуговує на щасливе життя.
        </p>

        <p className="default-about-text">
          Ми не просто рятуємо тварин з вулиці. Ми лікуємо їх, соціалізуємо, знаходимо найкращі домівки та супроводжуємо усиновлення на кожному етапі. Наша робота можлива завдяки пожертвам небайдужих людей.
        </p>
      </section>

      <div className="default-about-divider">
        <div className="default-about-divider-line"></div>
        <span className="default-about-divider-icon">❧</span>
        <div className="default-about-divider-line"></div>
      </div>

      <section className="default-about-stats">
        <div className="default-about-stats-grid">
          <div className="default-about-stat">
            <div className="default-about-stat-number">24</div>
            <div className="default-about-stat-label">Підопічних</div>
          </div>
          <div className="default-about-stat">
            <div className="default-about-stat-number">156</div>
            <div className="default-about-stat-label">Врятованих</div>
          </div>
          <div className="default-about-stat">
            <div className="default-about-stat-number">132</div>
            <div className="default-about-stat-label">Усиновлень</div>
          </div>
          <div className="default-about-stat">
            <div className="default-about-stat-number">5</div>
            <div className="default-about-stat-label">Років роботи</div>
          </div>
        </div>
      </section>

      <section className="default-documents-section">
        <div className="default-documents-header">
          <h2>Прозорість</h2>
          <p>Офіційні документи та звітність</p>
        </div>

        <div className="default-document-list">
          <a href="#" className="default-document-item">
            <div className="default-doc-icon">PDF</div>
            <div className="default-doc-info">
              <div className="default-doc-title">Свідоцтво про державну реєстрацію</div>
              <div className="default-doc-meta">ЄДРПОУ 12345678 · PDF · 245 KB</div>
            </div>
            <span className="default-doc-arrow">→</span>
          </a>

          <a href="#" className="default-document-item">
            <div className="default-doc-icon">PDF</div>
            <div className="default-doc-info">
              <div className="default-doc-title">Статут благодійної організації</div>
              <div className="default-doc-meta">Редакція 2022 · PDF · 520 KB</div>
            </div>
            <span className="default-doc-arrow">→</span>
          </a>

          <a href="#" className="default-document-item">
            <div className="default-doc-icon">PDF</div>
            <div className="default-doc-info">
              <div className="default-doc-title">Річна фінансова звітність 2023</div>
              <div className="default-doc-meta">Звіт за рік · PDF · 1.2 MB</div>
            </div>
            <span className="default-doc-arrow">→</span>
          </a>

          <a href="#" className="default-document-item">
            <div className="default-doc-icon">PDF</div>
            <div className="default-doc-info">
              <div className="default-doc-title">Звіт про використання пожертв</div>
              <div className="default-doc-meta">Q4 2023 · PDF · 890 KB</div>
            </div>
            <span className="default-doc-arrow">→</span>
          </a>
        </div>
      </section>

      <section className="default-donation-section">
        <div className="default-donation-inner">
          <h2 className="default-donation-title">Зробіть внесок</h2>
          <p className="default-donation-text">
            Ваша підтримка допомагає нам лікувати, годувати та знаходити дім для наших підопічних.
            Кожна гривня йде на благо тварин.
          </p>

          <div className="default-donation-card">
            <div className="default-donation-header">
              <span className="default-donation-bank">ПриватБанк</span>
              <span className="default-donation-badge">UAH</span>
            </div>
            <div className="default-donation-rows">
              <div className="default-donation-row">
                <span className="default-donation-label">Отримувач</span>
                <span className="default-donation-value">БО "жмут щастя"</span>
              </div>
              <div className="default-donation-row">
                <span className="default-donation-label">IBAN</span>
                <span className="default-donation-value">UA123456789012345678901234567</span>
              </div>
              <div className="default-donation-row">
                <span className="default-donation-label">ЄДРПОУ</span>
                <span className="default-donation-value">12345678</span>
              </div>
              <div className="default-donation-row">
                <span className="default-donation-label">SWIFT</span>
                <span className="default-donation-value">PBANUA2X</span>
              </div>
              <div className="default-donation-row">
                <span className="default-donation-label">Призначення</span>
                <span className="default-donation-value">Благодійна пожертва</span>
              </div>
            </div>
            <button className="default-copy-btn" onClick={copyIban}>
              Копіювати IBAN
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
